/**
 * Lead source attribution helper.
 *
 * On the landing we set `sessionStorage.pv_lead_source` from each CTA the user
 * clicks (hero-demo, hero-brochure, sticky-mobile, header-demo, footer-cta,...).
 * When the user actually submits a form, we read it and ship it to the backend
 * as the `source` field — fully backwards compatible (defaults to the form's
 * own fallback if no attribution is stored).
 */
export const LEAD_SOURCE_KEY = 'pv_lead_source';

export function setLeadSource(source) {
  if (!source) return;
  try {
    sessionStorage.setItem(LEAD_SOURCE_KEY, source);
  } catch (e) {
    /* sessionStorage may be unavailable (private mode, SSR) — ignore */
  }
}

export function getLeadSource(fallback) {
  try {
    const v = sessionStorage.getItem(LEAD_SOURCE_KEY);
    return v && v.trim() ? v : fallback;
  } catch (e) {
    return fallback;
  }
}

export function clearLeadSource() {
  try {
    sessionStorage.removeItem(LEAD_SOURCE_KEY);
  } catch (e) {
    /* ignore */
  }
}
